var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBamboo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 409.6 73.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#253858;}.cls-2{fill:#2684ff;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 16.06,
    y1: 10.61,
    x2: 16.06,
    y2: 53.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 15.91,
    y1: 10.61,
    x2: 15.91,
    y2: 53.94,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bamboo-blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blue"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.53,7.88C129.32,7.88,135,13.69,135,23c0,7-3.17,11.26-9.68,12.85,8.54,1.41,12.76,6.07,12.76,14.25,0,9.24-6.25,15.58-19.18,15.58H95.09V7.88ZM103,15.45V32.7h13.46c7.48,0,10.56-3.43,10.56-9s-3.34-8.27-10.56-8.27Zm0,24.29v18H119.2c7.57,0,11-2.73,11-8.54,0-6.16-3.26-9.5-11.17-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177,57.78c-2.82,5.81-8.1,8.8-14.87,8.8-11.7,0-17.6-9.94-17.6-22.88,0-12.41,6.16-22.88,18.48-22.88,6.42,0,11.35,2.9,14,8.62V21.7h7.57v44H177Zm-12.85,1.76c6.78,0,12.85-4.31,12.85-14.08V41.94c0-9.77-5.54-14.08-12-14.08-8.54,0-12.94,5.63-12.94,15.84C152.11,54.26,156.34,59.54,164.17,59.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.43,65.7h-7.57V39.12c0-7.92-3.17-11.44-10.38-11.44-7,0-11.88,4.66-11.88,13.55V65.7H196v-44h7.57v7.22a15.42,15.42,0,0,1,13.9-8.1c7.48,0,12.58,3.78,14.78,10.74,2.46-6.78,8.36-10.74,15.66-10.74,9.86,0,15.31,6.69,15.31,19.1V65.7h-7.57V41.23c0-9.06-3.17-13.55-10.38-13.55-7,0-11.88,4.66-11.88,13.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.38,66.58c-6.42,0-11.35-2.9-14-8.62V65.7h-7.57V3.31h7.57V29.62c2.82-5.81,8.1-8.8,14.87-8.8,11.7,0,17.6,9.94,17.6,22.88C313.86,56.1,307.7,66.58,295.38,66.58Zm-1.14-38.72c-6.78,0-12.85,4.31-12.85,14.08v3.52c0,9.77,5.54,14.08,12,14.08,8.54,0,12.94-5.63,12.94-15.84C306.29,33.14,302.06,27.86,294.23,27.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320,43.61c0-13.2,7.74-22.79,20.94-22.79s20.77,9.59,20.77,22.79-7.66,23-20.77,23S320,56.81,320,43.61Zm7.39,0c0,8.36,4.14,15.93,13.55,15.93S354.34,52,354.34,43.61s-4-15.75-13.37-15.75S327.41,35.25,327.41,43.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.89,43.61c0-13.2,7.74-22.79,20.94-22.79s20.77,9.59,20.77,22.79-7.66,23-20.77,23S367.89,56.81,367.89,43.61Zm7.39,0c0,8.36,4.14,15.93,13.55,15.93S402.21,52,402.21,43.61s-4-15.75-13.37-15.75S375.28,35.25,375.28,43.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.56,41.81H46.27a2,2,0,0,0-2,1.7A12.57,12.57,0,0,1,31.81,54.34l4.14,18.91A31.81,31.81,0,0,0,63.56,43.95,2,2,0,0,0,61.56,41.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.1,41.33l22-18.91a2,2,0,0,0,0-3L35.1.48A2,2,0,0,0,31.81,2V39.81A2,2,0,0,0,35.1,41.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M.3,45.94A31.81,31.81,0,0,0,31.81,73.55V54.34A12.56,12.56,0,0,1,19.25,41.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0,41.51v.3H19.25A12.56,12.56,0,0,1,31.81,29.28L27.68,10.37A31.79,31.79,0,0,0,0,41.51"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBamboo);
export default __webpack_public_path__ + "static/media/logo-bamboo.91d27ccd37991dfc81b4f977357b953d.svg";
export { ForwardRef as ReactComponent };